module.exports = __webpack_public_path__ + "img/circle-check-regular.0ffebfe3.svg";